module.exports = __webpack_public_path__ + "img/grass.be5030ca.webp";